import { createI18n } from "vue-i18n";
import en from "@/assets/locales/en.json";
import th from "@/assets/locales/th.json";
import ko from "@/assets/locales/ko.json";
import zh from "@/assets/locales/zh.json";
import ms from "@/assets/locales/ms.json";

const i18n = createI18n({
  legacy: false,
  locale: "en",
  fallbackLocale: "en",
  globalInjection: true,
  messages: {
    en: en,
    th: th,
    ko: ko,
    zh: zh,
    ms: ms,
  },
});

export default i18n;
